import { useEffect, useState, useMemo } from "react";
import FadeInSection from "../../components/FadeInSection";
import styles from "./BlogPreview.module.css";
import { FaArrowRight } from "react-icons/fa";
import deafultImg from "../../images/bloggen.jpg"

export default function BlogPreview({ content: data }) {
  const API_URL =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000/"
      : "https://api.hillerodfrimenighed.dk/";

  const [blog, setBlog] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const ac = new AbortController();
    (async () => {
      try {
        const res = await fetch(`${API_URL}blog/first`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          signal: ac.signal,
        });
        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const json = await res.json();
        setBlog(json);
      } catch (e) {
        if (e.name !== "AbortError") setError(e.message || "Fetch failed");
      }
    })();
    return () => ac.abort();
  }, [API_URL]);

  // Derive formatted date from blog; no extra state needed
  const formattedDate = useMemo(() => {
    if (!blog?.created_at) return null;
    const d = new Date(blog.created_at); // works for "YYYY-MM-DD HH:mm:ss" or ISO
    if (isNaN(d)) return null;
    return d.toLocaleDateString("da-DK", { day: "numeric", month: "long" });
  }, [blog?.created_at]);

  if(data == null){
    return (<div></div>);
  }

  return (
    <section className={styles.section}>
      <FadeInSection>
        <div className={styles.wrapper}>
            <h1>{data.header}</h1>
            <p dangerouslySetInnerHTML={{ __html: data.text }} />
            <a className={styles.button} href="/bloggen">
                <button>Læs alle indlæg her <FaArrowRight className={styles.Arrow}/></button>
            </a>
            {blog?.blog_id && (
            <a className={styles.blog} href={`/bloggen/${blog.blog_id}`}>
                {blog && (
                <div className={styles.imgContainer} style={{backgroundImage:`url(${blog.blog_image || deafultImg})`}}>
                
                <div className={styles.infoBox}>
                    {formattedDate && <p style={{color:"white"}}>{formattedDate}</p>}
                    {blog?.title && <h3>{blog.title}</h3>}
                    {blog?.author_name && <p className={styles.authorName}>{blog.author_name}</p>}
                    {!blog && !error && <p>Indlæser…</p>}
                    {error && <p className={styles.error}>Fejl: {error}</p>}
                </div>

                </div>
                )}
            </a>)}
        </div>
      </FadeInSection>
    </section>
  );
}
